import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=25d8beab&scoped=true"
import script from "./ClientTable.vue?vue&type=script&lang=js"
export * from "./ClientTable.vue?vue&type=script&lang=js"
import style0 from "./ClientTable.vue?vue&type=style&index=0&id=25d8beab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d8beab",
  null
  
)

export default component.exports